import styled from "styled-components";
import { cardStroke } from "@styles/cardStroke";
import { Text } from "@ifgengineering/component-library";

export const PortfolioInvestmentCardContainer = styled.div`
  display: grid;
  grid-template-columns: auto 60px;
  gap: 12px;
  padding: 16px;
  border-radius: 16px;
  background-color: ${({ theme }) => theme.colors.ui.background.raised};
  ${cardStroke}
  cursor: pointer;
`;

export const LeftSectionContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  gap: 12px;
`;

export const RightSectionContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: flex-end;
`;

export const TopLeftSectionContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  gap: 8px;
  height: 100%;
`;

export const HeadingWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

export const CurrentValueContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

export const GrowthContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`;

export const DealLogo = styled.img<{ $isFallback?: boolean }>`
  width: 60px;
  height: 60px;
  border-radius: 50%;
  object-fit: ${({ $isFallback }) => ($isFallback ? "contain" : "cover")};
`;

export const AssetClassContainer = styled.div<{ background: string }>`
  display: flex;
  justify-content: center;
  width: fit-content;
  align-items: center;
  padding: 4px 8px;
  border-radius: 8px;
  background-color: ${({ background }) => background};
  margin-top: 12px;
`;

export const AssetClassText = styled(Text)<{ textColor: string }>`
  color: ${({ textColor }) => textColor};
`;

export const TagsWrapper = styled.div`
  display: flex;
  gap: 16px;
  align-items: flex-end;
`;
